import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './cube-ui'
import api from './api'
import EncryptUtil from "./utils/encrypt";
import checkBrowser from './utils/checkBrowser'
import wxPay from './utils/wxPay'
//路边
import roadsidewxPay from './utils/roadsidewxPay'
import {formatDate, transDate} from "./utils/formatDate";
import weui from 'weui.js'
// import 'weui'
import Cookies from 'js-cookie'
// import wx from "weixin-jsapi";
import 'common/stylus/index.styl'
import "common/fonts/iconfont/iconfont.css"
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import {toPay} from './utils/pay'
//路边
import {roadsidePay} from './utils/pay'

import {loadScript} from './utils/loadScript'
import { getAdInfo } from "./utils/getAbInfo";
import noData from './components/weChat/components/noData'
require('es6-promise').polyfill();
Es6Promise.polyfill();
Vue.use(require('vue-wechat-title'));

Vue.config.productionTip = false;
import wx from 'weixin-js-sdk'
Vue.prototype.wx = wx

// Vue.prototype.wx = wx;
Vue.prototype.$pay = toPay;
//路边支付
Vue.prototype.$roadsidePay = roadsidePay;

Vue.prototype.$weui = weui;
Vue.prototype.$api = api;
Vue.prototype.$encryptUtil = EncryptUtil;
Vue.prototype.$loadScript = loadScript;
Vue.prototype.$getAdInfo = getAdInfo;
Vue.prototype.$wxPay = wxPay;
//路边
Vue.prototype.$roadsidewxPay = roadsidewxPay;
Vue.prototype.Cookies = Cookies;
Vue.prototype.formatDate = formatDate;
Vue.prototype.transDate = transDate;

Vue.prototype.checkBrowser = checkBrowser;
Vue.component("no-data",noData);



import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import { VueJsonp } from 'vue-jsonp'

Vue.use(VueJsonp);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
